/**
 * Canonical SafePsy social profiles.
 *
 * Single source of truth for both the /socials page and the footer link, so the
 * handles can never drift apart. `icon` maps to a brand glyph in
 * `components/BrandIcon.tsx`.
 */
export type SocialIcon = 'instagram' | 'linkedin' | 'x' | 'reddit' | 'discord'

export interface Social {
  icon: SocialIcon
  /** Platform name, used as the card heading. */
  name: string
  /** Handle, community name, or invite label as shown to the user. */
  handle: string
  /** One line explaining what people will find there. */
  description: string
  url: string
}

export const SOCIALS: Social[] = [
  {
    icon: 'instagram',
    name: 'Instagram',
    handle: '@SafePsy_',
    description: 'Product updates, design notes, and short posts on private mental health.',
    url: 'https://www.instagram.com/safepsy_/',
  },
  {
    icon: 'linkedin',
    name: 'LinkedIn',
    handle: 'SafePsy',
    description: 'Company news, hiring, and our work on privacy-first mental health.',
    url: 'https://www.linkedin.com/company/safepsycom/',
  },
  {
    icon: 'x',
    name: 'X',
    handle: '@SafePsy_',
    description: 'Short updates and replies as we ship the beta.',
    url: 'https://x.com/SafePsy_',
  },
  {
    icon: 'reddit',
    name: 'Reddit',
    handle: 'u/SafePsy',
    description: 'Our profile. Ask us anything directly.',
    url: 'https://www.reddit.com/user/SafePsy/',
  },
  {
    icon: 'reddit',
    name: 'Reddit community',
    handle: 'r/SafePsy',
    description: 'Discuss mental health, privacy, and SafePsy with the community.',
    url: 'https://www.reddit.com/r/SafePsy/',
  },
  {
    icon: 'discord',
    name: 'Discord',
    handle: 'Join the server',
    description: 'Chat with the team and other members in our community server.',
    url: 'https://discord.gg/qaeGEw446',
  },
]
